import * as Sentry from '@sentry/react'
import { env } from './env'

export const initSentry = () => {
  const dsn = env.current.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: env.current.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}

export const captureException = (error: unknown, context?: Record<string, unknown>) => {
  if (import.meta.env.DEV) console.error('[captureException]', error, context)
  Sentry.captureException(error, { extra: context })
}
